import { TbDrone } from "react-icons/tb";
import React, { useState } from "react";
import { useEffect } from "react";
import { FaAngleDown, FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import apiClient from "../../api/apiClient";
import colors from "../../config/colors";

export default () => {
  let initialState = {
    company_name: "",
    company_website: "",
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    dob: "",
    phone_number: "",
    category: "",
  };
  const [photographer, setPhotographer] = useState(initialState);
  const [showPassword, setShowPassword] = useState(true);
  const handleChange = (key, value) => {
    setPhotographer({ ...photographer, [key]: value });
  };

  // useEffect(() => {
  //   const fetch = async () => {
  //     const response = await apiClient.get("/photographerAccount");
  //     const data = response.data;
  //     setPhotographer(data);
  //   };
  //   fetch();
  // }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await apiClient.put("/photographerAccount", photographer);
    if (!result.ok) return toast.error("error");
    toast.success("Account Successfully update  ");
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content">
          <div className="p-4">
            <div className="site-content-body">
              <div className="input-fields row">
                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="company-name"
                    >
                      Company Name
                    </label>
                    <input
                      value={photographer.company_name}
                      onChange={(e) =>
                        handleChange("company_name", e.target.value)
                      }
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="company-name"
                    />
                  </div>

                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="company-Website"
                    >
                      Company Website
                    </label>
                    <input
                      value={photographer.company_website}
                      onChange={(e) =>
                        handleChange("company_website", e.target.value)
                      }
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="company-Website"
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="First-name">
                      First Name
                    </label>
                    <input
                      value={photographer.firstname}
                      onChange={(e) =>
                        handleChange("firstname", e.target.value)
                      }
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="First-name"
                      
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Last-name">
                      Last Name
                    </label>
                    <input
                      value={photographer.lastname}
                      onChange={(e) => handleChange("lastname", e.target.value)}
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="Last-name"
                      
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Email">
                      Email
                    </label>
                    <input
                      value={photographer.email}
                      onChange={(e) => handleChange("email", e.target.value)}
                      type="email"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="Email"
                      
                    />
                  </div>

                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Password">
                      Password
                    </label>
                    <div className="position-relative d-flex align-items-center">
                      <input
                        value={photographer.password}
                        onChange={(e) =>
                          handleChange("password", e.target.value)
                        }
                        type={showPassword ? "password" : "text"}
                        className="form-control m-1  px-2 py-1 pe-5 fs-4"
                        id="Password"
                        
                      />
                      <span
                        className="show-password"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <i className="bi bi-eye-fill"></i>
                        ) : (
                          <i className="bi bi-eye-slash-fill"></i>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="date-of-birth"
                    >
                      Date of Birth
                    </label>
                    <input
                      value={photographer.dob}
                      onChange={(e) => handleChange("dob", e.target.value)}
                      type="date"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="date-of-birth"
                    />
                  </div>

                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="Phone-Number"
                    >
                      Phone Number
                    </label>
                    <input
                      value={photographer.phone_number}
                      onChange={(e) =>
                        handleChange("phone_number", e.target.value)
                      }
                    
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="Phone-Number"
                    />
                  </div>
                </div>
              </div>
              <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                <label className="label blue-clr m-1 fs-4" htmlFor>
                  Select What Applies to you
                </label>
                <div className="select-applies-fields d-flex flex-wrap align-items-center justify-content-center">
                  <label
                    onClick={() => handleChange("picture",!photographer.picture)}
                    htmlFor
                    style={
                      photographer.picture
                        ? { backgroundColor: colors.primary }
                        : null
                    }
                    className="take-img m-2 px-4 py-1 fs-4"
                  >
                    <i
                      className="bi bi-camera-fill"
                      style={
                        photographer.picture
                          ? { color: "white" }
                          : null
                      }
                    />
                  </label>
                  <label
                    onClick={() => handleChange("video", !photographer.video)}
                    htmlFor
                    style={
                      photographer.video
                        ? { backgroundColor: colors.primary }
                        : null
                    }
                    className="take-img m-2 px-4 py-1 fs-4"
                  >
                    <i
                      className="bi bi-camera-video-fill"
                      style={
                        photographer.video
                          ? { color: "white" }
                          : null
                      }
                    />
                  </label>
                  <label
                    onClick={() => handleChange("drone", !photographer.drone)}
                    htmlFor
                    style={
                      photographer.drone 
                        ? { backgroundColor: colors.primary }
                        : null
                    }
                    className="take-img m-2 px-4 py-1 fs-4"
                  >
                    <TbDrone
                      style={
                        photographer.drone 
                          ? { color: "white" }
                          : null
                      }
                    />
                  </label>
                </div>
                <button
                  type="submit"
                  className="save-changes btn_bgnone blue-clr p-3 fs-4 border-0 "
                >
                  <span className="pe-2">Save Changes</span>
                  <FaCheck />
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
